module.exports = __webpack_public_path__ + "media/images/metronic/social/pintrest-66446efd0f97e9136f54d84ca6489af0.png";